import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpInterceptor } from "@angular/common/http";
import { catchError, mergeMap } from "rxjs/operators";
import { throwError, from } from "rxjs";
import { LogoutService } from "../../auth/logout.service";

@Injectable({
  providedIn: "root",
})
export class OutOfLicenseHttpInterceptorService implements HttpInterceptor {
  constructor(private logoutService: LogoutService) {}

  intercept(req, next) {
    return next.handle(req).pipe(
      catchError((err) => {
        if (this.isOutOfLicense(err)) {
          return from(this.logout()).pipe(
            mergeMap(() => {
              return throwError(err);
            })
          );
        } else  {
          return throwError(err);
        }
      })
    );
  }

  logout() {
    return this.logoutService.logout();
  }

  isOutOfLicense(e) {
    return (
      e instanceof HttpErrorResponse &&
      e.status === 401 &&
      e.error &&
      (e.error.indexOf("Unauthorised. Licence could not be obtained.") > -1 ||
        e.error.indexOf("Invalid Entitlement. Status: Denied") > -1 ||
        e.error.indexOf("Invalid Entitlement. Status: NoLicense") > -1)
    );
  }
}
